import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=de8be12a&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8be12a')) {
      api.createRecord('de8be12a', component.options)
    } else {
      api.reload('de8be12a', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=de8be12a&", function () {
      api.rerender('de8be12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uAtIBOO0Bat4/JS/comp/childrenage.vue"
export default component.exports